import { useEffect } from 'react';
import { useStateDispatch, useStateSelector } from '../store';
import { getUserInformation } from '../reducers/user/userReducer';

const useAuthentication = () => {
  const dispatch = useStateDispatch();
  const isLoggedIn = useStateSelector((state) => state.user.isLoggedIn);
  const logInStatus = useStateSelector((state) => state.user.logInStatus);
  const isAuthenticating = logInStatus !== 'COMPLETE';

  useEffect(() => {
    if (!isLoggedIn && logInStatus === 'PENDING') {
      const logInUser = async (): Promise<void> => {
        await dispatch(getUserInformation());
      };
      logInUser();
    }
  }, [dispatch, isLoggedIn, logInStatus]);

  return { isAuthenticating };
};

export default useAuthentication;
